export class TrainingProviderSearchForm {
    constructor(
        public trainingProviderName: string = "",
        public trainingProgramId: string = '00000000-0000-0000-0000-000000000000',
        public trainingTypeIdCommaSeparated: string = '',
        public cpoApprovalStatus: string = '',
        public pageIndex: number = 0,
        public captchaToken: string = ''
    ) { }




}